import parser from 'accept-language-parser';
import { DEFAULT_COUNTRY, DEFAULT_LANG } from 'apps/auth/constants/Constants';

export const isShortActiveUrl = (url = '') => {
    const regexp = new RegExp(`^/(l|b|new/b)-`);
    return regexp.test(url);
};

export const pushPath = (sourceRoutes = [], routs) => {
    sourceRoutes.forEach((r) => {
        if (Array.isArray(r.path)) {
            r.path.forEach((path) => {
                routs.push({ ...r, path: path });
            });
        } else {
            routs.push(r);
        }
    });
    return routs;
};

export const normalizePathname = (url = '') => {
    if (!url) return url;

    let pathname = url;
    const queryIndex = url.indexOf('?');
    const hashIndex = url.indexOf('#');
    if (queryIndex !== -1 && hashIndex !== -1) {
        pathname = url.slice(0, Math.min(queryIndex, hashIndex));
    } else if (queryIndex !== -1) {
        pathname = url.slice(0, queryIndex);
    } else if (hashIndex !== -1) {
        pathname = url.slice(0, hashIndex);
    }

    if (pathname.length > 1) {
        return pathname.replace(/\/+$/, '');
    }

    return pathname;
};

export const getLangAndCountryFromUrl = (url = '', userLangCookie, acceptLanguage = '', cloudflareIpCountry = '') => {
    let lang = DEFAULT_LANG;
    let country;

    const langURI = getLanguage(url);

    if (isLanguageOnly(langURI)) {
        lang = langURI;
        country = cloudflareIpCountry || DEFAULT_COUNTRY;
    } else if (checkPrefix('_', langURI)) {
        const arr = langURI.split('_');
        lang = arr[0];
        country = arr[1] || DEFAULT_COUNTRY;
    } else if (checkPrefix('-', langURI)) {
        const arr = langURI.split('-');
        lang = arr[0];
        country = arr[1] || DEFAULT_COUNTRY;
    } else if (isLangCountry(userLangCookie, '-')) {
        const arr = userLangCookie.split('-');
        lang = arr[0];
        country = arr[1] || DEFAULT_COUNTRY;
    } else {
        country = cloudflareIpCountry || DEFAULT_COUNTRY;

        let parseArray = parser.parse(acceptLanguage);
        if (Array.isArray(parseArray) && parseArray.length > 0) {
            let actualLangInfo = parseArray.at(0);
            lang = actualLangInfo.code || DEFAULT_LANG;
        }
    }

    return { lang: lang, country: country };
};

const checkPrefix = (prefix, lang) => {
    return isLangCountry(lang, prefix);
};

const isLanguageOnly = (lang) => {
    return /^[a-z]{2,3}$/i.test(lang || '') && !NON_LANGUAGE_PATH_PREFIXES.has(String(lang || '').toLowerCase());
};

const isLangCountry = (value, separator = '-') => {
    const escapedSeparator = separator.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp(`^[a-z]{2,3}${escapedSeparator}[a-z]{2}$`, 'i').test(value || '');
};
const getLanguage = (referrer) => {
    if (!referrer) return null;

    if (referrer === '/alipay') {
        return 'zh';
    }

    // Remove "/api" if it's present at the beginning of the referrer
    const cleanedReferrer = referrer.startsWith('/api') ? referrer.slice(4) : referrer;

    const language = cleanedReferrer.split('/')[1];
    return language || null;
};

const NON_LANGUAGE_PATH_PREFIXES = new Set(['api', 'pdf', 'web']);
